<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>

    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BFormTextarea, BAlert, BButton,
} from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'

export default {
  name: 'Contents',
  components: {
    BFormGroup,
    BFormInput,
    BAlert,
    BButton,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
